import { render, staticRenderFns } from "./DetailImageGallery.vue?vue&type=template&id=4dfee30c&scoped=true&"
import script from "./DetailImageGallery.vue?vue&type=script&lang=ts&"
export * from "./DetailImageGallery.vue?vue&type=script&lang=ts&"
import style0 from "./DetailImageGallery.vue?vue&type=style&index=0&id=4dfee30c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfee30c",
  null
  
)

export default component.exports